<template>
	<el-dialog
	  :title="title"
	  :visible.sync="isShow"
	   id='publicImportDialog'
	   width="500px" 
	   :close-on-click-modal="false"
	  >
	  <div v-loading='isImportFilesLoading' element-loading-text="正在上传文件...">
          <div class="fliesUplaod"  >
            <div class='stepTwo'>
                <h4 class='color333'>步骤1：导出模板</h4>
                <p>下载当前模板完善后导入：<el-button type="text" class='handleDownload' @click='downLoadTemplate'>点击下载模板</el-button></p>
            </div>
            <div class='stepThree'>
                 <h4 class='color333'>步骤2：导入表单</h4>
                   <div class="uploads">
                      <el-upload
                        drag
                        :action="uploadUrl"
                        :show-file-list='true'
                        :auto-upload="false"
                        :on-change="OnChange"
                        :on-remove="OnRemove"
                        :before-remove="beforeRemove"
                        :limit='handleLimit'
                        ref='upload'
                        >
                        <i class="el-icon-upload"></i>
                        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                        <div class="el-upload__tip" slot="tip">只能上传.xls/.xlsx文件，且不超过5M</div>
                      </el-upload>
                    </div>
            </div>
          </div>
          <div slot="footer" class="dialog-footer">
            <el-button size="small" class='minButton' @click="handleUploadAdd">确定导入</el-button>
          </div>
        </div>
	</el-dialog>
</template>
<script>
	import {uploadUrl} from "@/assets/js/apiConfig.js" 
	export default {
		props:{
			isPublicImportShow:{
				type:Boolean,
				default:false
			},
			title:{
				type:String,
				default:"导入"
			},
			isImportFilesLoading:{
				type:Boolean,
				default:false
			},
			handleLimit:{
				type:Number,
				default:1
			}
		},
		data() {
			return {
				uploadUrl,
				fileList:[],
			}
		},
		created() {

		},
		computed:{
			isShow:{
				get() {
					return this.isPublicImportShow;
				},
				set(val) {
					this.$emit('update:isPublicImportShow',val)
				}
			}
		},
		methods:{
			downLoadTemplate() {
				this.$emit('downLoadTemplate',true)
			},
			handleUploadAdd() {
				if(!this.fileList.length) {
					return this.$message.error('系统未检测到上传的文件！')
				}
				this.$emit('exportIn',this.fileList)
			},
			// 移出提示
		    beforeRemove(file, fileList) {
	           return this.$confirm(`确定移除 ${ file.name }？`);
	        },
		      // 传入文件监听
		    OnChange(file,fileList){
		        this.fileList=fileList
		    },
		      // 移出操作
		    OnRemove(file,fileList){
		        this.fileList=fileList
		    },
		},
		watch:{
			isImportFilesLoading(val) {
				if(!val) {
					this.fileList=[];
              		this.$refs.upload.clearFiles();
				}
			}
		}
	}
</script>
<style lang="less">
	#publicImportDialog {
		.el-dialog {
        .el-dialog__header {
          padding: 17px 20px;
          border-bottom: 1px solid #E5E5E5;
          .el-dialog__title {
            color: #333;
            font-size: 14px;
            font-weight: 600;
          }

        }
        .el-dialog__body {
              padding: 18px 20px;
              .fliesUplaod{
			      .fliesUplaod_text {
			        color: #EC681D;
			        display: inline-block;
			        margin-bottom: 20px;
			      }
			      .handleDownload {
			        margin: 3px 0 18px 0;
			      }
			      .uploads{
			        padding:15px 0px;
			        .el-upload-dragger {
			          width: 250px;
			          height: 90px;
			          .el-icon-upload {
			            font-size: 35px;
			            margin: 0;
			            line-height: 45px;
			          }
			        }
			      }

			      /*new*/
			      .stepOne {
			        p {
			          margin-top: 10px;
			          margin-left: 30px;
			        }
			      }
			    }
			    .dialog-footer {
			      text-align: right;
			    }
        }
      }
	}
</style>


// WEBPACK FOOTER //
// src/components/importDialog/importFile.vue